import React from "react";
import { Box, Typography, Paper, useTheme } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceArea,
} from "recharts";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";


  const primary = colorTheme('palette', 'primary').value
  const primaryBg = colorTheme('palette', 'primaryBg').value
  const positive = colorTheme('palette', 'positive').value
  const positiveBg = colorTheme('palette', 'positiveBg').value
  const negative = colorTheme('palette', 'negative').value
  const negativeBg = colorTheme('palette', 'negativeBg').value
  const neutral = colorTheme('palette', 'neutral').value
  const neutralBg = colorTheme('palette', 'neutralBg').value
  const agent = colorTheme('palette', 'agent').value
  const agentBg = colorTheme('palette', 'agentBg').value




const data = [
  { time: "0:00", agent: "Neutral", customer: "Negative" },
  { time: "2:00", agent: "Neutral", customer: "Negative" },
  { time: "4:00", agent: "Neutral", customer: "Negative" },
  { time: "6:00", agent: "Positive", customer: "Negative" },
  { time: "8:00", agent: "Neutral", customer: "Negative" },
  { time: "10:00", agent: "Positive", customer: "Negative" },
  { time: "12:34", agent: "Neutral", customer: "Negative" },
];

//  Use only 3 sentiment levels
function convertSentimentToValue(sentiment) {
  switch (sentiment) {
    case "Positive":
      return 1;
    case "Neutral":
      return 0;
    case "Negative":
      return -1;
    default:
      return 0;
  }
}

function convertValueToSentiment(value) {
  switch (value) {
    case 1:
      return "Positive";
    case 0:
      return "Neutral";
    case -1:
      return "Negative";
    default:
      return "Neutral";
  }
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Paper elevation={3} sx={{ p: 1, backgroundColor: "white" }}>
        <Typography variant="body2">{`Time: ${label}`}</Typography>
        <Typography variant="body2" color={agent}>
          {`Agent: ${convertValueToSentiment(payload[0]?.value)}`}
        </Typography>
        <Typography variant="body2" color={agent} >
          {`Agent Sentence: ${payload[0].payload?.agentText || "NA"}`}
        </Typography>
        <Typography variant="body2"color={primary}> 
          {`Customer: ${convertValueToSentiment(payload[1]?.value)}`}
        </Typography>
        <Typography variant="body2" color={primary} >
          {`Customer Sentence: ${payload[1].payload?.customerText || "NA"}`}
        </Typography>
      </Paper>
    );
  }
  return null;
};



export default function SentimentGraph({ sentimentGraph }) {
  console.log(sentimentGraph,'sentigraph');
  const theme = useTheme();
  const processedData = sentimentGraph?.map((item) => ({
    time: item?.time,
    agent: item?.agent && convertSentimentToValue(item?.agent),
    agentText: item?.agentText,
    customer: item.customer && convertSentimentToValue(item.customer),
    customerText: item?.customerText,
  }));
  const highlightedPeriods = [
    { start: "3:30", end: "4:30" },
    { start: "7:30", end: "8:30" },
  ];
  return (
    <Box sx={{ width: "100%", height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={processedData}
          margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="time" />
          <YAxis
            domain={[-1, 1]}
            ticks={[-1, 0, 1]}
            tickFormatter={(value) => convertValueToSentiment(value)}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            align="right"
            verticalAlign="top"
            wrapperStyle={{ paddingBottom: "10px" }}
          />

          {/* Highlighted periods */}
          {highlightedPeriods?.map((period, index) => (
            <ReferenceArea
              key={index}
              x1={period.start}
              x2={period.end}
              fill="#ffecef"
              fillOpacity={0.3}
            />
          ))}

          <Line
            type="monotone"
            dataKey="agent"
            stroke={agent}
            name="Agent"
            strokeWidth={2}
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="customer"
            stroke={primary}
            name="Customer"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}
